import {v4 as uuidv4} from 'uuid';

import {VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {VisualizationTypeToParameters} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';

import {VisualizationConfig, VisualizationType} from './SharedUniversalBlockViewTypes';

/**
 * Create a `VisualizationConfig` from a given id, type, and parameters.
 *
 * The goal of this function is to make it slightly easier for the caller to define visualization configs when
 * using `PresentationalUniversalBlockView` without having to know the details of the GraphQL Shape.
 */
export default function makeVisualizationConfig<TVisualizationType extends VisualizationType>(
  type: TVisualizationType,
  parameters: Omit<VisualizationTypeToParameters[TVisualizationType], '__typename'>
): VisualizationConfig & {parameters: VisualizationTypeToParameters[TVisualizationType]} {
  return {
    __typename: 'AnalyticsVisualizationNode',
    id: uuidv4(),
    // @ts-expect-error TypeScript doesn't know that VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME[type] will return
    // a __typename string that matches the corresponding parameters.
    parameters: {
      __typename: VISUALIZATION_TYPE_TO_PARAMETERS_TYPENAME[type],
      ...parameters,
    },
  };
}
